// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/hover.proto" (package "bianka.event.activity.v2", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../core/enrichment/organization";
import { User } from "../../../core/enrichment/user";
import { Order } from "../../../core/enrichment/order";
import { Gig } from "../../../core/enrichment/gig";
import { Page } from "../../../common/activity/v1/page";
import { Element } from "../../../common/activity/v1/element";
/**
 * Next serial number to be used: 10
 *
 * @generated from protobuf message bianka.event.activity.v2.Hover
 */
export interface Hover {
    /**
     * The type of the hover
     *
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * Data regarding the hovered element
     *
     * @generated from protobuf field: bianka.common.activity.v1.Element element = 2;
     */
    element?: Element;
    /**
     * Data regarding the page where the hover happened
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page page = 8;
     */
    page?: Page;
    /**
     * Enrichments
     *
     * @generated from protobuf field: bianka.core.enrichment.Gig gig = 3;
     */
    gig?: Gig;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Order order = 4;
     */
    order?: Order;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User user = 5;
     */
    user?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User buyer = 6;
     */
    buyer?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User seller = 7;
     */
    seller?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 9;
     */
    organization?: Organization;
}
// @generated message type with reflection information, may provide speed optimized methods
class Hover$Type extends MessageType<Hover> {
    constructor() {
        super("bianka.event.activity.v2.Hover", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "bianka.core.extension.required": true } },
            { no: 2, name: "element", kind: "message", T: () => Element },
            { no: 8, name: "page", kind: "message", T: () => Page },
            { no: 3, name: "gig", kind: "message", T: () => Gig },
            { no: 4, name: "order", kind: "message", T: () => Order },
            { no: 5, name: "user", kind: "message", T: () => User },
            { no: 6, name: "buyer", kind: "message", T: () => User },
            { no: 7, name: "seller", kind: "message", T: () => User },
            { no: 9, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.Hover
 */
export const Hover = new Hover$Type();
